import edgeCommon from '../common';
import apiService from '../apiService';

let users = function() {
    
    let addValidations = function() {

        $("#update-user").validate({
            ignore: "",
            errorClass: "text-danger",
            rules: {},
        });
    }

    let usersAction = function() {
        $("#user-action").change(function () {
            let checkedVal = $(".selected-user:checkbox:checked").map(function () {
                    return this.value;
                }).get();

            if (checkedVal == "") {
                $(this).val("");
                edgeCommon.swalWarning("Please check at-least one checkbox");
            } else {
                if ($(this).val() != "") {
                    let user_action = $(this).val();
                    if ("delete" == user_action) {
                        deleteUsers(user_action, checkedVal);
                    } else {
                        Swal.fire({
                            title: "Are you sure?",
                            text: "You want to perform " + user_action + " action",
                            icon: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#3085d6",
                            cancelButtonColor: "#d33",
                            confirmButtonText: "Yes, Update it!",
                            closeOnClickOutside: false,
                            allowOutsideClick: false,
                        }).then((result) => {
                            if (result.isConfirmed) {
                                apiService.postRequest(
                                    baseUrl + "/admin/users/user-actions",
                                    {
                                        user_action: user_action,
                                        user_ids: checkedVal,
                                    }
                                );
                            }
                            $(this).val("");
                        });
                    }
                }
            }
        });

        let deleteUsers = (user_action, checkedVal) => {
            Swal.fire({
                title: "Are you sure?",
                text: "You want to perform " + user_action + " action",
                icon: "warning",
                showDenyButton: true,
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Permanent Delete",
                denyButtonText: `Archive`,
                denyButtonColor: "#ffc107",
                closeOnClickOutside: false,
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed || result.isDenied) {
                    let deleteType = result.isConfirmed ? "permanent" : "archive";
                    apiService.postRequest(
                        baseUrl + "/admin/users/user-actions",
                        {
                            user_action: user_action,
                            user_ids: checkedVal,
                            deleteType: deleteType,
                        }
                    );
                }
                $("#user-action").val("");
            });
        };

        $("#archive-user-action").change(function () {
            let checkedVal = $(".selected-user:checkbox:checked")
                .map(function () {
                    return this.value;
                })
                .get();

            if (checkedVal == "") {
                $(this).val("");
                edgeCommon.swalWarning("Please check at-least one checkbox");
            } else {
                if ($(this).val() != "") {
                    let user_action = $(this).val();
                    let actionText = "You want to perform restore action";
                    if (user_action == "permanent") {
                        actionText =
                            "You want to perform permanent delete action";
                    }

                    Swal.fire({
                        title: "Are you sure?",
                        text: actionText,
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Yes, Update it!",
                        closeOnClickOutside: false,
                        allowOutsideClick: false,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            apiService.postRequest(
                                baseUrl + "/admin/users/archive-user-actions",
                                {
                                    user_action: user_action,
                                    user_ids: checkedVal,
                                },
                            );
                        }
                        $(this).val("");
                    });
                }
            }
        });

        //Open Modal pop up
        $(document).on("click", ".edit-details", function () {
            let id = $(this).data("id");
            $.ajax({
                url: baseUrl + "/admin/users/edit/" + id,
                type: "GET",
                success: function (response) {
                    if (response.user) {
                        $("#userModal").modal("toggle");
                        $("#user_id").val(response.user.id);
                        $("#internal").val(response.user.internal);
                        $("#notes").val(response.user.notes);
                    }
                },
            });
        });

        $(document).on("click", ".user-info", function () {
            let id = $(this).data("id");
            $.ajax({
                url: baseUrl + "/admin/users/info/" + id,
                type: "GET",
                success: function (response) {
                    if (response.user) {
                        $("#userInfoModal").modal("toggle");
                        $("#userStrongBox").html(response.user.totalStrongBox);
                        $("#userVms").html(response.user.vms);
                        $("#userStorage").html(response.user.storage + " GB");
                        $("#userGroups").html(response.user.groups.toString());
                        $("#companySize").html(response.user.company_size);
                        $("#companyBudget").html(response.user.company_budget);
                        $("#hearAboutUs").html(response.user.hear_about_us);
                        $("#interestedInHelping").html(response.user.interested_in_helping);
                        $("#userCreated").html(response.user.created_at);
                        $("#userLastLog").html(response.user.last_login);
                    }
                },
            });
        });

        $(document).on("click", ".payment-mode", function () {
            let id = $(this).data("id");
            $.ajax({
                url: baseUrl + "/admin/users/edit/" + id,
                type: "GET",
                success: function (response) {
                    if (response.user) {
                        $("#paymentModeModal").modal("toggle");
                        $("#pay_mode_user_id").val(response.user.id);
                        $("#payment_mode").val(response.user.payment_mode);
                    }
                },
            });
        });
        
        $("#save-payment-mode").click(function () {
            $(".loading").removeClass("d-none");
            let formData = $("#update-payment-mode").serialize();
            apiService.postRequest(
                baseUrl + "/admin/users/update-payment-mode",
                formData
            );
        });

        $("#save-user").click(function () {
            if ($("#update-user").valid()) {
                $(".loading").removeClass("d-none");
                let formData = $("#update-user").serialize();
                apiService.postRequest(
                    baseUrl + "/admin/users/store",
                    formData
                );
            }
        });

        //Open Modal pop up
        $(document).on("click", ".edit-strongbox", function () {
            let id = $(this).data("id");
            $.ajax({
                url: baseUrl + "/admin/strongbox/edit/" + id,
                type: "GET",
                success: function (response) {
                    if (response.strongbox) {
                        $("#strongBoxModal").modal("toggle");
                        $("#strongbox_id").val(response.strongbox.id);
                        $("#project_name").val(response.strongbox.project_name);
                        $("#group_id").val(response.strongbox.group_id);
                        if (response.strongbox.keyword) {
                            $("#keyword").importTags(response.strongbox.keyword);
                        }
                    }
                },
            });
        });
        
        $(document).on("click", ".update-status", function () {
            let id = $(this).data("id");
            let status = $(this).data("status");

            status = $(this).prop("checked") ? "approve" : "reject";

            Swal.fire({
                title: "Are you sure?",
                text: "You want to " + status + " this user",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, Do it!",
            }).then((result) => {
                if (result.isConfirmed) {
                    apiService.postRequest(
                        baseUrl + "/admin/users/status-update",
                        {
                            user_id: id,
                            status: status,
                        }
                    );
                } else {
                    $(this).prop("checked", !$(this).prop("checked"));
                }
            });
        });
        
        $(document).on("click", ".active_status", function () {
            let newStatus = "";
            let currentStatus = "";
            let id = [];
            id.push($(this).data("userid"));
            if ($(this).prop("checked")) {
                newStatus = "active";
                currentStatus = "inactive";
            } else {
                newStatus = "inactive";
                currentStatus = "active";
            }
            Swal.fire({
                title: "Are you sure?",
                text: "You want to change user status " + currentStatus + " to " + newStatus,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, Do it!",
            }).then((result) => {
                if (result.isConfirmed) {
                    apiService.postRequest(
                        baseUrl + "/admin/users/user-actions",
                        {
                            user_action: newStatus,
                            user_ids: id,
                        },
                        false
                    );
                } else {
                    $(this).prop("checked", !$(this).prop("checked"));
                }
            });
        });

        $(document).on("click", ".apply_late_fees", function () {
            let newStatus = "";
            let currentLabel = "";
            let id = [];
            id.push($(this).data("userid"));
            if ($(this).prop("checked")) {
                newStatus = "lateFeesOn";
                currentLabel = "You want to charge late fees";
            } else {
                newStatus = "lateFeesOff";
                currentLabel = "You don`t want to charge late fees";
            }
            Swal.fire({
                title: "Are you sure?",
                text: currentLabel,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, Do it!",
            }).then((result) => {
                if (result.isConfirmed) {
                    apiService.postRequest(
                        baseUrl + "/admin/users/user-actions",
                        {
                            user_action: newStatus,
                            user_ids: id,
                        },
                        false
                    );
                } else {
                    $(this).prop("checked", !$(this).prop("checked"));
                }
            });
        });

        $(document).on("click", ".allow_to_build_nsxt_setup", function () {
            let newStatus = "";
            let currentLabel = "";
            let id = [];
            id.push($(this).data("userid"));
            if ($(this).prop("checked")) {
                newStatus = "allowNsxtSetupBuild";
                currentLabel = "Do you want to allow to build NSXT setup";
            } else {
                newStatus = "notAllowNsxtSetupBuild";
                currentLabel = "You don`t want to allow to build NSXT setup";
            }
            Swal.fire({
                title: "Are you sure?",
                text: currentLabel,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, Do it!",
            }).then((result) => {
                if (result.isConfirmed) {
                    apiService.postRequest(
                        baseUrl + "/admin/users/user-actions",
                        {
                            user_action: newStatus,
                            user_ids: id,
                        },
                        false
                    );
                } else {
                    $(this).prop("checked", !$(this).prop("checked"));
                }
            });
        });
        
        $(document).on("click", ".process-nsxt-account", function () {
            $(".loading").removeClass("d-none");
            let id = $(this).data("id");
            $.ajax({
                url: baseUrl + "/admin/users/process-nsxt-account/" + id,
                type: "GET",
                success: function (response) {
                    $(".loading").addClass("d-none");
                    if( response.status == "success" ){
                        edgeCommon.swalSuccess(response.message).then(() => {
                            window.location.reload();
                        });
                    } else {
                        edgeCommon.swalError(response.message);
                    }
                },
            });
        });

        $(document).on("click", ".process-nsxt-site", function () {
            let id = $(this).data("id");
            let siteId = $(this).data("siteid");
            let companyId = $(this).data("companyid");
            // $(".loading").removeClass("d-none");
            // $.ajax({
            //     url: baseUrl + '/admin/users/process-nsxt-site',
            //     type: "POST",
            //     dataType: "JSON",
            //     data: { user_id: id, site_id: siteId, company_id: companyId },
            //     success:function(response) {
            //         $(".loading").addClass("d-none");
            //         edgeCommon.swalSuccess(response.message).then(() => {
            //             window.location.reload();
            //         });

            //     }
            // });
            apiService.postRequest(
                baseUrl + "/admin/users/process-nsxt-site",
                {
                    user_id: id,
                    site_id: siteId,
                    company_id: companyId,
                }
            );
        });

        $(document).on("change", "#sites", function () {
            let userId = $(this).data('userid');
            let siteId = $(this).val();
            window.location.href = baseUrl + "/admin/users/details/"+userId+"/"+siteId;
        });
    
    }
    
    return {
        // public functions
        init: function () {
            addValidations();
            usersAction();
        },
    };
}();

$(document).ready(function () {
    users.init();
    $(".notes, .update-status").tooltip();

    $("#users-table").DataTable({
        processing: true,
        serverSide: false,
        // paginate: false,
        info: false,
        pageLength: 25,
        lengthMenu: [
            [25, 50, 100, 200, -1],
            [25, 50, 100, 200, "All"],
        ],
        // order: [[ 1, "desc" ]],
        // columnDefs: [
        //     { orderable: false, targets: [-2, -1, 0] }
        // ]
    });
});

